import React from 'react';
import moment from "moment";
import Swal from "sweetalert2";

import { useTranslation } from "react-i18next";
import * as yup from "yup";

import * as commonFunc from 'scripts/common';

import CChart from 'components/CChart';

import {
    Input, Button,
    Label,
    FormGroup, FormFeedback,
    InputGroup, InputGroupText, Col
} from "reactstrap";


export default function ChartFrag(props) {
    const { data, formManager, modelFctManager, bindPropResult, parentProps, isConfiguration, parentDisabled, accessList } = props;

    const { t } = useTranslation();
    const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };
    const { register, setValue, resetField, errors } = formManager;


    const [shouldRender, setShouldRender] = React.useState(false);
    const [altData, setAltData] = React.useState({ labels: [], datasets: [] });
    const [refreshData, setRefreshData] = React.useState(false);

    React.useEffect(() => {
        if (data.onActionEvents && data.onActionEvents["onLoad"]) {
            data.onActionEvents["onLoad"].forEach((args, index) => {
                modelFctManager.onActionRequired(data.name, args, data).then(actionResponse => {
                    console.debug("RESPONSE");
                    console.debug(actionResponse);
                    if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: actionResponse.errorMessage
                        });
                    }
                });
            });
        }

        if ((!data.children || data.children.length === 0) && modelFctManager && modelFctManager.finalizeProcess) modelFctManager.finalizeProcess(data, parentProps);
    }, []);


    React.useEffect(() => {
        var srcArgs = data.argumentsObj?.loadObj;
        var args = {};
        if (srcArgs && Object.keys(srcArgs).length && srcArgs.url) {
            Object.keys(srcArgs).forEach((key) => {
                var valueArgs = srcArgs[key];
                if (valueArgs.startsWith && valueArgs.startsWith("prop:")) args[key] = (accessList[commonFunc.camelize(valueArgs.replace("prop:", ""), true)] || {}).defaultValue;
                else args[key] = valueArgs;
            });

            var url = "../" + srcArgs.url;
            commonFunc.getMethod(url, args).then((responseData) => {
                var dataRes = responseData.data;
                if (dataRes.isSuccess) {
                    //console.debug(dataRes.result);

                    var pile = {};
                    var pileTargets = data.argumentsObj?.pileTargets || [];
                    dataRes.result.forEach((userStatement, index) => {
                        pileTargets.forEach((pileObj) => {
                            if (!pile[pileObj.key]) pile[pileObj.key] = [];
                            if (pileObj.format) {
                                switch (pileObj.format) {
                                    case "date":
                                        pile[pileObj.key].push(userStatement[pileObj.target]);
                                        //pile[pileObj.key].push(moment(userStatement[pileObj.target], "YYYY-MM").format("MMM YYYY"));
                                        break;
                                    default:
                                        pile[pileObj.key].push(userStatement[pileObj.target]);
                                        break;
                                }
                            }
                            else {
                                pile[pileObj.key].push(userStatement[pileObj.target]);
                            }
                        });
                    });

                    var datasets = data.argumentsObj?.datasets;
                    setAltData({
                        labels: pile.labels,
                        datasets: datasets.map(dataset => {
                            dataset.data = pile[dataset.cTarget];
                            return dataset;
                        }),
                    });

                } else {
                    /*Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_fail"),
                        html: context.props.i18nManager.t("gal_failLoadModels") + " :<br>" + dataModels.errorMessage
                    });*/
                }
            });
        }

    }, [refreshData]);

    React.useEffect(() => {
        data.childRendered = 0;
        if (isConfiguration && modelFctManager && modelFctManager.commonRenderProc) modelFctManager.commonRenderProc(data);
    }, [props]);
    if (!isConfiguration && modelFctManager && modelFctManager.commonRenderProc) modelFctManager.commonRenderProc(data);

    data.functionManager = {};
    data.functionManager.getParentProps = () => { return parentProps; };
    data.functionManager.rerender = () => { setShouldRender(!shouldRender) };

    const { ref: refElem, ...restElem } = register(bindPropResult);

    var disabled = ((data.disabled ? true : false) || (!data.ignoreParentDisabled ? parentDisabled : false));

    var btnClass = "m-1";
    var btnSupClass = "";
    var btnStyle = { width: "100%", height: "250px" };
    var frameClass = "";
    var frameStyle = {};
    if (data.hidden) {
        if (isConfiguration) {
            frameClass += " config-hidden";
        }
        else {
            frameClass += " d-none";
        }
    }
    if (data.checkRights) {
        var hasRights = modelFctManager.checkRights(data.checkRights.entity, data.checkRights.rights);
        if (!hasRights) frameClass += " d-none";
    }

    var design = data.customDesign?.design;
    design = modelFctManager.prepareMergedDesign(data, design, "default_chart");
    data.mergedDesign = design;
    if (design) {
        if (design.boxSize) {
            var supBoxSize = modelFctManager.manageBoxSize("item-" + parentProps?.parentData?.gridID + "-" + data?.key, design.boxSize, data);
            frameClass += supBoxSize;
            btnClass += supBoxSize;
        }

        if (design.height) btnStyle.height = design.height;
        if (design.width) btnStyle.width = design.width;

        if (design.margin) {
            btnStyle.margin = design.margin;
            btnClass = btnClass.replace("m-1", "");
        }
        if (design.marginTop) {
            if (design.marginTop.indexOf("px") >= 0) {
                btnStyle.marginTop = design.marginTop;
            }
            else {
                btnSupClass += design.marginTop;
            }
        }

        if (design.fontColor) btnStyle.color = modelFctManager.getRgbaFromHex(design.fontColor);
        Object.assign(btnStyle, modelFctManager.setCustomBackground(design));
    }


    var baseForm = <div>
        <Button className="btn btn-simple btn-rotate btn-dark btn-sm px-2 mt-0 mb-0" onClick={() => { setRefreshData(!refreshData); }}><i className="fa fa-sync"></i>{t("gal_refresh")}</Button>
        <CChart type={data.subType || "line"} redraw
            className="d-inline-block align-top"
            style={btnStyle}
            data={altData}
            options={data.argumentsObj?.chartOptions} />
    </div>;


    return <Col data-name="ChartFrag" data-element={data.objType} xs="auto" className={` ${frameClass} ${parentProps.parentData.customDesign && parentProps.parentData.customDesign.design && parentProps.parentData.customDesign.design.spacing ? "" : "p-0"}`} style={frameStyle}>{baseForm}</Col>;//align-self-center
}